module.exports = __webpack_public_path__ + "static/bugtracking_collage_less_border-613b9b16abf604cdeaba37bcd044552a.png";